<template>
  <v-container class="pa-0">
    <h1 class="display-1 font-weight-light">{{ title }}</h1>
    <v-row>
      <v-col cols="12" md="3" xl="2"  v-for="(video, index) in videos" :key="index" v-show="isIndexInPage(index)">
        <video-card :id_video="video"></video-card>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      class="text-center mt-10"
      v-if="loaded && videos.length === 0"
    >
      <v-col cols="12">
        <span >{{ $t('favorites.messages.no-results') }}</span>
      </v-col>
      <v-col cols="12">
        <v-btn :to="{ name: 'Explore' }" color="primary">
          <v-icon>search</v-icon>
          {{ $t('favorites.buttons.explore') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-pagination
          v-if="pages"
          v-model="page"
          :length="pages"
          circle
          next-icon="chevron_right"
          prev-icon="chevron_left"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>

import VideoCardComponent from '@/components/VideoCard'

export default {
  components: {
    'video-card': VideoCardComponent
  },
  data: () => ({
    loaded: false,
    videos: [],
    title: '',
    page: 1,
    pages: null,
    items_per_page: 8
  }),

  mounted() {
    this.title = this.$t('favorites.titles.main')
    this.searchVideos()
  },

  methods: {
    searchVideos() {
      let favorites = this.$store.getters.user.favorites
      if (favorites.length === 0) {
        this.loaded = true
        return
      }
      this.pages = Math.ceil(favorites.length / this.items_per_page)
      this.page = 1
      this.videos = favorites
      this.loaded = true
    },
    isIndexInPage(index) {
      let page = (index + 1) / this.items_per_page
      return Math.ceil(page) <= this.page
    }
  }
}

</script>
